import { Box, Text, useTheme, Tooltip } from "@chakra-ui/react";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Quiz } from "../../models/Quiz";
import { StudentTableSubmission } from "../../models/StudentTableItem";
import { useTranslation } from "react-i18next";

type Props = {
  index: number;
  quiz: Quiz;
  submissions: StudentTableSubmission[];
};

export default function QuizProgressItem({ index, quiz, submissions }: Props) {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const submission = useMemo(
    () => submissions.find((sm) => sm.quiz.id === quiz.id),
    [quiz.id, submissions],
  );

  const onClick = useCallback(() => {
    navigate(`./quizzes/${quiz.id}`, {
      state: { submissionId: submission?.id },
    });
  }, [navigate, quiz.id, submission?.id]);

  return (
    <Tooltip
      label={`${t(submission ? "common.labels.done" : "common.labels.todo")}`}
    >
      <Box
        cursor={submission ? "pointer" : "default"}
        width={9}
        height={9}
        display="flex"
        justifyContent="center"
        alignItems="center"
        bg={submission ? theme.colors.primary[200] : "white"}
        borderColor={submission ? theme.colors.primary.DEFAULT : "gray.300"}
        borderWidth={2}
        borderRadius={4}
        onClick={submission && onClick}
        transform={"rotate(45deg) scale(0.8)"}
      >
        <Text
          transform={"rotate(-45deg) scale(1.2)"}
          as="span"
          fontSize="md"
          fontWeight={500}
        >
          {index}
        </Text>
      </Box>
    </Tooltip>
  );
}
